"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var INSTRUMENT_TABLE_ITEMS = {
  lastPrice: 'lastPrice',
  dailyPercentageChange: 'dailyPercentageChange',
  bid: 'bid',
  ask: 'ask',
  dailyVolume: 'dailyVolume',
  dailyMin: 'dailyMin',
  dailyMax: 'dailyMax'
};
var _default = exports["default"] = INSTRUMENT_TABLE_ITEMS;